<template>
  <v-container>
     <v-card  class="mx-auto"
    
    outlined>
     <v-card-text>
     <h1 class="text-center ma-5" >Family History Collection Guide</h1>
     <p>  <v-btn @click='downloadPDF' rounded color="primary" dark>Download PDF <v-icon class='ml-1' medium>mdi-download</v-icon></v-btn></p> 
     <p class="text-center ma-10 font-weight-regular title">To help get you prepared to fill out your My Genetic Trust, we’ve put together a
Family History Collection Guide. Although you can update your My Genetic
Trust at any time, it may be helpful to try to gather some information from
family members ahead of time.</p>

<v-row class='ma-4'>
    <v-flex
                          xs12
                          sm7>
        <p class=' font-weight-bold mt-5 title'>
    Information that is helpful to get, if possible, includes:
</p>
        <li class='font-weight-regular title'>Any health conditions that your relatives have
(such as diabetes, cancer, childhood illnesses, etc)</li>
<li  class='font-weight-regular title'>Any history of children who were born with health
issues or passed away at young ages</li>
<li  class='font-weight-regular title'>Any history of miscarriage or stillbirth</li>
<li  class='font-weight-regular title'>Any history of intellectual or developmental delays</li>
<li  class='font-weight-regular title'>The age they were diagnosed with the health issue</li>
<li  class='font-weight-regular title'>Date of birth and/or age that they died</li>
    </v-flex>
    <v-col cols="3"><img src='../assets/staticAsset/GSF_Sketch-Family-Color-00.jpg' /></v-col>
</v-row>
 
<v-row>

    <v-col cols="12" >
  <p class=" font-weight-regular mt-5 title ">Don’t worry about recording things like surgeries or allergies unless it seems
related to an underlying health condition. It is also OK if there are some
relatives that you cannot gather health history information on.</p>
    </v-col>

</v-row>

<p class="font-weight-regular title text-center ma-5">Talking about personal health history is a sensitive topic for many people. Here
are some talking points about why discussing family health history is important
and tips on how to record it.</p>

<div class='ma-10'>
<li  class='font-weight-regular title'>Information about family health history is one way we determine someone’s risk
for many common health conditions such as heart disease or cancer.</li>
<li  class='font-weight-regular title'>By discussing their health history, family members may be helping other relatives
improve their ability to prevent or screen for a variety of medical conditions.</li>
<li  class='font-weight-regular title'>Family health history is like a puzzle; the more pieces we get the more complete
the picture is.</li>
<li  class='font-weight-regular title'>Taking notes can be helpful to record details more accurately. Try several possible
avenues, like family reunions, family Facebook groups, and email, whenever
comfortable.</li>
</div>
<br/>
<p class=' font-weight-regular title mt-5'>Family dynamics can make conversations around sensitive topics difficult, and it is not
uncommon for there to be parts of the family that we just cannot get information on.
Remember that you can always update your My Genetic Trust as you learn more
information about your family health history.
</p>
<p class=' font-weight-regular title'>Some people are comfortable discussing private information, while others are not.
Pushing to gather information if someone is not receptive is rarely effective and may
damage your relationship with that person if they feel pressured.
</p>
<p class=' font-weight-regular title'>If any of the above tips are not helpful, it is OK to let that relative know that you
understand that they have reservations. You can encourage them to reach out if they
change their mind or have more questions. It is very common to have one or more
branches of our family trees that we're unable to get information on, and that’s OK.</p>
 </v-card-text>
     </v-card>
  </v-container>
</template>

<script>
export default {
  methods : {
    downloadPDF(){
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.download = name;
      a.target = "blank";
      a.href = "https://storage.googleapis.com/genetictrust-dev.appspot.com/public/Family%20History%20Collection%20Guide.pdf";
      a.click();
    }
  }
}
</script>

<style>

</style>